import _ from 'lodash'
import {
	L2TabularListRoot,
	L2TabularListHeader,
	L2TabularListContent,
} from '../l2/L2TabularList'
import {
	L2TabularListItemSummary,
} from '../l2/L2TabularListItem'
import L1Tip from '../l1/L1Tip'

/**
 * WARNING
 * Once this goes to production, these hardcoded models cannot change without
 * discussion, because it would change the form—  and forms are supposed to
 * stay the same from a legal perspective once they start getting used for
 * real data.  Also, JSON based on them will have been recorded into the
 * database and any change may cause loads of previous data to break or render
 * incorrectly.  This will not be an issue once they are being dynamically
 * defined in the Flow XML along with everything else.
 */
export interface L3FpoHumanoidListModel {
	Site: string,
}

const newModel = (): L3FpoHumanoidListModel => {
	return {
		Site: '',
	}
}

interface L3FpoHumanoidListProps {
	models?: L3FpoHumanoidListModel[],
}

export const L3FpoHumanoidList = ({models = []}: L3FpoHumanoidListProps) => {
	const items = _.map(models, (model, modelIdx) => {
		return (
			<L2TabularListItemSummary key={modelIdx}>
				<div>{model.Site}</div>
			</L2TabularListItemSummary>
		)
	})
	return (
		<L2TabularListRoot columnCount={5}>
			<L2TabularListHeader>
				<div>
					Site
				</div>
			</L2TabularListHeader>
			<L2TabularListContent>
				{items}
			</L2TabularListContent>
		</L2TabularListRoot>
	)
}
